import Vue from 'vue';
import VueRouter from 'vue-router';
// import NProgress from 'vue-nprogress';
import Notifications from 'vue-notification';
import { VueMaskDirective } from 'v-mask';
// import VueToast from 'vue-toast-notification';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import ElementUI from 'element-ui';
import VeeValidate, { Validator } from 'vee-validate';
import Toast from 'vue-toastification';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

import './prototypes';
import 'vue-toastification/dist/index.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icons/icons.css';
import './theme/icons/icons.css';
import './theme/scss/global.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

Vue.directive('mask', VueMaskDirective);

const dictionary = {
  en: {
    messages: {
      required: (fieldName) => `"${fieldName.capitalize()}" is required`,
      email: () => 'Email must be a valid',
    },
  },
};

Vue.use(Notifications);
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(VeeValidate);
// Vue.use(VueToast);
Vue.use(PerfectScrollbar);
Vue.use(Toast);
// Vue.use(NProgress);
Validator.localize(dictionary);

Vue.config.productionTip = false;
// const nprogress = new NProgress();

new Vue({
  // nprogress,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
